import studioPreset from "./tailwind-preset.shared.js";

export default studioPreset;
